/** Makes share one logo across passenger cars and vans. */
export const LOGO_VEHICLE_TYPE = 'VEHICLETYPE_PASSENGER_CAR';
